import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa3ec386"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa3ec386')) {
      api.createRecord('aa3ec386', component.options)
    } else {
      api.reload('aa3ec386', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa3ec386", function () {
      api.rerender('aa3ec386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/index.vue"
export default component.exports